export default __webpack_public_path__ + "static/media/logo_new_crop.5b4d111b.svg";